import { TIMELINE_SIDE } from '../types';

import type { CycleData, SideType } from '../types';

export function cyclesOverlap(cycleA: CycleData, cycleB: CycleData): boolean {
	if (cycleA.paired_cycle_id === cycleB.id || cycleB.paired_cycle_id === cycleA.id) {
		return false;
	}

	return cycleA.start < cycleB.end && cycleB.start < cycleA.end;
}

function overlapsAnyLaterCycle(cycle: CycleData, laterCycles: CycleData[]): boolean {
	const overlaps = laterCycles.some((other) => cyclesOverlap(cycle, other));

	return overlaps;
}

export function hasOverlapWithinSet(cycles: CycleData[]): boolean {
	const hasOverlap = cycles.some((cycle, index) => overlapsAnyLaterCycle(cycle, cycles.slice(index + 1)));

	return hasOverlap;
}

function appliesToSide(cycle: CycleData, side: SideType): boolean {
	const isBothSides = cycle.side === TIMELINE_SIDE.BILATERAL || cycle.side === undefined;
	const matches = cycle.side === side || isBothSides;

	return matches;
}

export function hasSameSideOverlap(cycles: CycleData[]): boolean {
	const leftCycles = cycles.filter((cycle) => appliesToSide(cycle, TIMELINE_SIDE.LEFT));
	const rightCycles = cycles.filter((cycle) => appliesToSide(cycle, TIMELINE_SIDE.RIGHT));
	const hasOverlap = hasOverlapWithinSet(leftCycles) || hasOverlapWithinSet(rightCycles);

	return hasOverlap;
}
